import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import FormData from 'form-data';
import path from 'path';

// Assuming PrefData and other dependencies are available
// import { getSessionToken } from './prefdata';
// import { isNetworkAvailable } from './network_status';
import { BASE_URL, APP_TOKEN } from '../configs';
import { getAccessToken } from '../pages/Protected';

const isNetworkAvailable =  () => true;

enum HttpMethod {
  GET = 'GET',
  POST = 'POST',
  DELETE = 'DELETE',
  PUT = 'PUT'
}

export async function buildHeaderTokens(isStripePayment: boolean = false, request?: any): Promise<Record<string, string>> {
  const userToken = getAccessToken()?.toString() || '';

  const header: Record<string, string> = {
    // 'Cache-Control': 'no-cache',
    // 'Access-Control-Allow-Headers': '*',
    // 'Access-Control-Allow-Origin': '*',
    // 'Content-Type': 'application/json; charset=UTF-8',
    // 'usertoken': userToken,
    'Authorization': `${APP_TOKEN}`,
    'Accept': 'application/json; charset=utf-8'
  };

  return header;
}

async function buildHttpResponse(
  // endPoint: string,
  // method: HttpMethod = HttpMethod.GET,
  // request?: any,
  // isStripePayment: boolean = false,
  // customHeader?: Record<string, string>
  {
    endPoint,
    method = HttpMethod.GET,
    body,
    isStripePayment = false,
    customHeader
  }: {
    endPoint: string,
    method?: HttpMethod,
    body?: any,
    isStripePayment?: boolean,
    customHeader?: Record<string, string>
  
  }
): Promise<any> {
  if (await isNetworkAvailable()) {
    const headers = await buildHeaderTokens(isStripePayment, body);
    const url = buildBaseUrl(endPoint);

    const config: AxiosRequestConfig = {
      method,
      url,
      headers: customHeader ?? headers,
      data: body,
      responseType: 'json'
    };

    try {
      const response: AxiosResponse = await axios(config);
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response) {
          console.error(`Error (${method}) ${error.response.status}: ${error.response.data}`);
          throw error.response.data.message || 'Something Went Wrong';
        } else {
          throw 'Your internet is not working';
        }
      } else {
        throw 'An unknown error occurred';
      }
    }
  } else {
    throw 'Your internet is not working';
  }
}

export function buildBaseUrl(endPoint: string): string {
  if (!endPoint.startsWith('http')) return `${BASE_URL}/${endPoint}`;
  return endPoint;
}

async function handleResponse(response: AxiosResponse, avoidTokenError?: boolean): Promise<any> {
  if (!await isNetworkAvailable()) {
    throw 'Your internet is not working';
  }
  if (response.status === 401) {
    throw 'Token Expired';
  }

  if (response.status >= 200 && response.status <= 206) {
    return response.data;
  } else {
    throw response.data.message || 'Something Went Wrong';
  }
}

function handleErrorResponse(response: AxiosResponse): Record<string, any> {
  return {
    status: response.status,
    message: 'Something Went Wrong',
  };
}


// export async function buildHttpReq(
//   {
//     endpoint, 
//     method = 'GET',
//     body = null,
//     header= {},
//     customUrl
    
//   }:
//   {
//     endpoint?: string,
//     method?: string,
//     body?: any,
//     header?: any
//     customUrl?: string
//   }
// ){
//   // convert body to form data
//   const formData = new FormData();
//   Object.keys(body).forEach(key => formData.append(key, body[key]));
//   const response = await fetch(endpoint != null ? buildUrl(endpoint) : customUrl != null ? customUrl: ""  , {
//     method: method,
//     headers: {
//       ...header
//     },
//     body: formData
//   });
//   return await response.json();
// }

export async function buildFormDataRequest(
  {
    endpoint, 
    method = 'GET',
    body = null,
    customUrl 
  }:
  {
    endpoint?: string,
    method?: string,
    body?: any,
    customUrl?: string
  }){
    const formData = new FormData();
    Object.keys(body).forEach(key => formData.append(key, body[key]));
    const response = await fetch(endpoint != null ? buildBaseUrl(endpoint) : customUrl != null ? customUrl: ""  , {
      method: method,
      headers:await buildHeaderTokens(),
      body: formData as any
    });

    return await response.json();

  }


  /**
 * Dynamically builds a multipart/form-data request for file upload.
 * This function will allow you to upload a file with an optional title.
 * The user is authenticated using the Authorization token in the header.
 * 
 * @param params - Object containing endpoint, method, file, title, and custom headers.
 */
 async function uploadFileWithFormData({
  endpoint,
  method = HttpMethod.POST,
  file,
  title,
  customHeaders = {},
}: {
  endpoint: string;
  method?: HttpMethod; // Default to POST
  file: File;
  title?: string;
  customHeaders?: Record<string, string>;
}): Promise<any> {
  // Check if the network is available
  if (!isNetworkAvailable()) {
    throw 'Your internet is not working';
  }

  // Build the FormData object for multipart/form-data
  const formData = new FormData();
  formData.append('file', file);  // Append the file to the form data
  if (title) formData.append('title', title);  // Append the title if provided

  // Build headers dynamically, including Authorization token
  const headers = {
    ...customHeaders,
    'Content-Type': 'multipart/form-data',
    Authorization: `${getAccessToken() || ''}`,  // Assuming you fetch the token using `getAccessToken()`
  };

  // Build Axios config
  const config: AxiosRequestConfig = {
    url: buildBaseUrl(endpoint),
    method: method,  // POST by default
    headers,
    data: formData,
  };

  try {
    // Perform the file upload request
    const response: AxiosResponse = await axios(config);
    return handleResponse(response);  // Handle success response
  } catch (error) {
    if (axios.isAxiosError(error)) {
      if (error.response) {
        // Log detailed error if available
        console.error(`Error (${method}) ${error.response.status}: ${error.response.data}`);
        throw error.response.data || 'Something Went Wrong';
      } else {
        throw 'Your internet is not working';
      }
    } else {
      throw 'An unknown error occurred';
    }
  }
}
// Example usage


export {
    buildHttpResponse,
    handleResponse,
    uploadFileWithFormData,
    HttpMethod,
    // buildMultipartRequest,
    handleErrorResponse
    };


  
